import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Auth pages
import AdminLogin from './pages/auth/AdminLogin';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import CandidateLogin from './pages/auth/CandidateLogin';
import OTPVerify from './pages/auth/OTPVerify';

// Admin pages
import Dashboard from './pages/admin/Dashboard';
import ExamList from './pages/admin/ExamList';
import ExamCreate from './pages/admin/ExamCreate';
import ExamEdit from './pages/admin/ExamEdit';
import ExamDetail from './pages/admin/ExamDetail';
import ResultsList from './pages/admin/ResultsList';
import Reports from './pages/admin/Reports';
import CandidateManagement from './pages/admin/CandidateManagement';
import AuditLog from './pages/admin/AuditLog';
import QuestionBank from './pages/admin/QuestionBank';
import ManualGrading from './pages/admin/ManualGrading';

// Candidate pages
import CandidateExamList from './pages/candidate/ExamList';
import ExamLobby from './pages/candidate/ExamLobby';
import ExamTaking from './pages/candidate/ExamTaking';
import ExamResult from './pages/candidate/ExamResult';

// Guards
import AdminRoute from './guards/AdminRoute';
import CandidateRoute from './guards/CandidateRoute';

const App = () => {
  const { user } = useSelector((s) => s.auth);

  return (
    <Routes>
      {/* Root redirect */}
      <Route
        path="/"
        element={
          user?.role === 'admin'
            ? <Navigate to="/admin/dashboard" replace />
            : user?.role === 'candidate'
            ? <Navigate to="/candidate/exams" replace />
            : <Navigate to="/login" replace />
        }
      />

      {/* Auth */}
      <Route path="/login" element={<CandidateLogin />} />
      <Route path="/verify-otp" element={<OTPVerify />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/forgot-password" element={<ForgotPassword />} />
      <Route path="/admin/reset-password" element={<ResetPassword />} />

      {/* Admin routes */}
      <Route path="/admin/dashboard" element={<AdminRoute><Dashboard /></AdminRoute>} />
      <Route path="/admin/exams" element={<AdminRoute><ExamList /></AdminRoute>} />
      <Route path="/admin/exams/new" element={<AdminRoute><ExamCreate /></AdminRoute>} />
      <Route path="/admin/exams/:id" element={<AdminRoute><ExamDetail /></AdminRoute>} />
      <Route path="/admin/exams/:id/edit" element={<AdminRoute><ExamEdit /></AdminRoute>} />
      <Route path="/admin/exams/:id/results" element={<AdminRoute><ResultsList /></AdminRoute>} />
      <Route path="/admin/reports" element={<AdminRoute><Reports /></AdminRoute>} />
      <Route path="/admin/candidates" element={<AdminRoute><CandidateManagement /></AdminRoute>} />
      <Route path="/admin/audit-log" element={<AdminRoute><AuditLog /></AdminRoute>} />
      <Route path="/admin/question-bank" element={<AdminRoute><QuestionBank /></AdminRoute>} />
      <Route path="/admin/exams/:id/grading" element={<AdminRoute><ManualGrading /></AdminRoute>} />

      {/* Candidate routes */}
      <Route path="/candidate/exams" element={<CandidateRoute><CandidateExamList /></CandidateRoute>} />
      <Route path="/candidate/exams/:id/lobby" element={<CandidateRoute><ExamLobby /></CandidateRoute>} />
      <Route path="/candidate/exams/:id/take" element={<CandidateRoute><ExamTaking /></CandidateRoute>} />
      <Route path="/candidate/exams/:id/result" element={<CandidateRoute><ExamResult /></CandidateRoute>} />

      {/* 404 */}
      <Route path="*" element={<div className="min-h-screen flex items-center justify-center text-gray-500 text-xl">404 — Page Not Found</div>} />
    </Routes>
  );
};

export default App;
